export class Waiter {

  waiting: (string | undefined)[];
  doneQueue: (() => void)[];
  options: {};
  timer: number | undefined;

  constructor(private name?: string) {
    this.waiting = [];
    this.doneQueue = [];
  };

  add(id?: string) {
    const that = this;
    this.waiting.push(id);
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.timer = window.setTimeout(function recurse() {
      console.log('(debug) ' + (that.name ? (that.name + ' ') : '') + 'Waiting for ' + that.waiting.join(','));
      that.timer = window.setTimeout(recurse, 5000);
    }, 5000);
    return function(func: () => void) {
      that.done(id, func);
    };
  }


  async done(func?: (() => void)): Promise<boolean>;
  async done(id?: string, func?: (() => void)): Promise<boolean>;
  async done(...args: any[]): Promise<boolean> {
    let i = 0;
    let id: string | undefined = (typeof(args[i]) === 'string') ? args[i++] : undefined;
    let func: (() => {}) = (typeof(args[i]) === 'function') ? args[i++] : undefined;

    if (func) {
      this.doneQueue.push(func);
    }
    for (let i=0; i<this.waiting.length; i++) {
      if (this.waiting[i] === id) {
        this.waiting.splice(i, 1);
        break;
      }
    }
    if (this.waiting.length === 0) {
      for (let i=0; i<this.doneQueue.length; i++) {
        await this.doneQueue[i].call(this);
        this.doneQueue.splice(i--, 1);
      }
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = undefined;
      }
      return true;
    } else {
      return false;
    }
  }


  isDone(id?: string) {
    // if id = undefined, any undefined item will work
    for (let i=0; i<this.waiting.length; i++) {
      if (this.waiting[i] === id) {
        return false;
      }
    }
    return true;
  }
}